// TapDebugger.js — temporary helper to find what's swallowing taps
import { useEffect } from 'react';

export default function TapDebugger() {
  useEffect(() => {
    if (!/(\?|&)tapdebug(=1)?(&|$)/.test(window.location.search)) return;

    const highlight = (el) => {
      const prev = el.style.outline;
      el.style.outline = '2px solid red';
      setTimeout(() => { el.style.outline = prev; }, 600);
    };

    const onDown = (e) => {
      const x = e.clientX ?? (e.touches && e.touches[0]?.clientX);
      const y = e.clientY ?? (e.touches && e.touches[0]?.clientY);
      if (x == null || y == null) return;

      const top = document.elementFromPoint(x, y);
      if (!top) return;

      // Visual: outline what actually received the tap
      highlight(top);

      // Log some clues
      const cs = getComputedStyle(top);
      // eslint-disable-next-line no-console
      console.log(
        '[TapDebug] target:',
        top.tagName, top.className || '', 
        { pointerEvents: cs.pointerEvents, zIndex: cs.zIndex, position: cs.position }
      );
    };

    document.addEventListener('pointerdown', onDown, { passive: true });
    document.addEventListener('touchstart', onDown, { passive: true });

    return () => {
      document.removeEventListener('pointerdown', onDown);
      document.removeEventListener('touchstart', onDown);
    };
  }, []);

  return null;
}